import { useEffect } from 'react';

// The only fonts actually installed as system fonts (no network fetch needed) among the options
// offered in `ReviewPaletteStep`'s heading/body font pickers. Everything else in those pickers is
// a Google Font that must be loaded before it will render correctly.
const SYSTEM_FONTS = new Set([
  'Aptos Display',
  'Aptos',
  'Arial',
  'Calibri',
  'Helvetica',
  'Times New Roman',
]);

function googleFontLinkId(fontFamily: string): string {
  return `brand-asset-builder-google-font-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
}

function loadGoogleFont(fontFamily: string): void {
  if (SYSTEM_FONTS.has(fontFamily)) {
    return;
  }
  const linkId = googleFontLinkId(fontFamily);
  if (document.getElementById(linkId)) {
    return;
  }
  const familyParam = encodeURIComponent(fontFamily).replace(/%20/g, '+');
  const link = document.createElement('link');
  link.id = linkId;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${familyParam}:wght@400;600;700&display=swap`;
  document.head.appendChild(link);
}

export function useGoogleFont(fontFamily: string): void {
  useEffect(() => {
    loadGoogleFont(fontFamily);
  }, [fontFamily]);
}
